module.exports = __webpack_public_path__ + "static/img/cdn-node.0e8acfc0.png";